import axios from 'axios'

export default {
  namespaced: true,
  
  state: () => ({
    londonboutique: {}, // safe default
    genevaboutique: {},
    siteSettings: {},
  }),

  mutations: {
    SET_LONDON(state, data) {
      state.londonboutique = data
    },
    SET_GENEVA(state, data) {
      state.genevaboutique = data
    },
    SET_SETTINGS(state, data) {
      state.siteSettings = data
    },
  },

  actions: {
    async fetchLondon({ commit, state }) {
      // fetch only if the object is empty
      if (!state.londonboutique || !Object.keys(state.londonboutique).length) {
        const res = await axios.get('/api/londonboutique')
        commit('SET_LONDON', res.data?.data?.[0] || {})
      }
    },
    async fetchGeneva({ commit, state }) {
      if (!state.genevaboutique || !Object.keys(state.genevaboutique).length) {
        const res = await axios.get('/api/genevaboutique')
        commit('SET_GENEVA', res.data?.data?.[0] || {})
      }
    },
    async fetchSiteSettings({ commit, state }) {
      if (!state.siteSettings || !Object.keys(state.siteSettings).length) {
        const res = await axios.get('/api/sitesettings')
        commit('SET_SETTINGS', res.data?.data?.[0] || res.data || {})
      }
    },
  },

  getters: {
    london: (state) => state.londonboutique,
    geneva: (state) => state.genevaboutique,
    settings: (state) => state.siteSettings,
  },
}
